import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import 'assets/scss/components/locationModal.css';

import Toaster from 'components/Toaster';
import ChargeCreditCardForm from '../../Form/payment/chargeCreditCard';
import ConfirmCharge from '../../Form/payment/confirmCharge';
import BillingAddressApi from '../../../apis/BillingAddress';

export const MODAL_CONTENT = [
  {
    name: 'Charge Form',
  },
  {
    name: 'Confirm Charge',
  },
];

const ChargeCreditCardModal = ({
  isVisible,
  onCancel,
  toggleSuccessModal,
  businessName,
  businessId,
  chargeCard,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [chargeDetails, setChargeDetails] = useState({});

  useEffect(() => {
    setCurrentStep(0);
  }, [isVisible]);

  const chargeCreditCard = () => {
    const { amount, description } = chargeDetails;
    const { id } = chargeCard;
    const data = { amount, description };
    BillingAddressApi.charge(id, data)
      .then(() => {
        toggleSuccessModal({ type: 'charge', amount, description });
        onCancel();
        Toaster.getSuccessToaster('check-circle', 'Successfully charged card');
      })
      .catch(() => {
        Toaster.getErrorToaster('exclamation-triangle', 'Error charging card');
      });
  };

  const handleNext = () => {
    if (currentStep === MODAL_CONTENT.length - 1) {
      chargeCreditCard();
    } else setCurrentStep(currentStep + 1);
  };

  return (
    <Modal
      className="location-modal credit-card-modal"
      isOpen={isVisible}
      toggle={onCancel}
      onClickBackdrop={onCancel}
    >
      <ModalHeader className="text-center">
        <div className="modal-title d-inline text-bold">
          Update Your Payment Plan
        </div>
        <span role="none" className="close-modal" onClick={onCancel}>
          <FontAwesomeIcon icon="times" />
        </span>
      </ModalHeader>
      <ModalBody className="pt-3 pb-0 pl-4 pr-4">
        {currentStep === 0 && (
          <ChargeCreditCardForm
            handleNext={handleNext}
            onCancel={onCancel}
            setChargeDetails={setChargeDetails}
          />
        )}
        {currentStep === 1 && (
          <ConfirmCharge
            businessName={businessName}
            handleNext={handleNext}
            onCancel={onCancel}
            chargeDetails={chargeDetails}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

ChargeCreditCardModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleSuccessModal: PropTypes.func.isRequired,
};

export default ChargeCreditCardModal;



// WEBPACK FOOTER //
// ./src/components/Modal/creditCard/chargeCreditCard.js